import { render, staticRenderFns } from "./TemplateMarketPreviewItem.vue?vue&type=template&id=2511965f&scoped=true"
import script from "./TemplateMarketPreviewItem.vue?vue&type=script&lang=js"
export * from "./TemplateMarketPreviewItem.vue?vue&type=script&lang=js"
import style0 from "./TemplateMarketPreviewItem.vue?vue&type=style&index=0&id=2511965f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2511965f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2511965f')) {
      api.createRecord('2511965f', component.options)
    } else {
      api.reload('2511965f', component.options)
    }
    module.hot.accept("./TemplateMarketPreviewItem.vue?vue&type=template&id=2511965f&scoped=true", function () {
      api.rerender('2511965f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/templateMarket/component/TemplateMarketPreviewItem.vue"
export default component.exports